import { stringifyQs } from "@dashboard/utils/urls";
import urlJoin from "url-join";

export const cmsPagesSection = "/content/cms-pages";
export const cmsPagesListPath = cmsPagesSection;
export const cmsPageAddPath = urlJoin(cmsPagesSection, "add");
export const cmsPagePath = (id: string) => urlJoin(cmsPagesSection, id);

export const cmsPagesListUrl = (params?: Record<string, string | number | undefined>) =>
  cmsPagesListPath + "?" + stringifyQs(params);

export const cmsPageAddUrl = () => cmsPageAddPath;

export const cmsPageUrl = (id: string) => cmsPagePath(encodeURIComponent(id));
